import type { CSSProperties } from 'react';

interface Props {
  size?: number;
  className?: string;
  style?: CSSProperties;
}

// PokeBinder mark: a fanned hand of cards — the act of collecting. Rendered in
// currentColor so it tints to the surrounding text/accent in either theme, and
// never relies on a specific (copyrighted) shape or palette.
export function LogoMark({ size = 24, className, style }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={className}
      style={style}
    >
      <rect
        x="13.5"
        y="8"
        width="13"
        height="21"
        rx="3"
        transform="rotate(-26 20 30)"
        stroke="currentColor"
        strokeWidth="2.1"
      />
      <rect
        x="13.5"
        y="8"
        width="13"
        height="21"
        rx="3"
        transform="rotate(26 20 30)"
        stroke="currentColor"
        strokeWidth="2.1"
      />
      <rect
        x="13.5"
        y="8"
        width="13"
        height="21"
        rx="3"
        fill="currentColor"
        fillOpacity="0.16"
        stroke="currentColor"
        strokeWidth="2.4"
      />
      <line x1="16.5" y1="13.5" x2="23.5" y2="13.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
